import { trackingBasePart } from "./constants";

export default {
  trackingEvent: () => `${trackingBasePart}/tracking-events`,
  bulkTrackingEvent: () => `${trackingBasePart}/bulk-tracking-events`,
};
